import React, { FC, memo } from 'react';
import _map from 'lodash/map';
import { useGenderIdentityOptions } from '../../shared/hooks';
import { FilterData } from '../../shared/types';
import { Label, StyledFormikCheckbox } from '../../shared/styles';

type Props = FilterData;

const AdditionallyIdentifiesAs: FC<Props> = ({ name, label }) => {
  const genderIdentityOptions = useGenderIdentityOptions();

  return (
    <>
      <Label>{label}</Label>
      <div>
        {_map(genderIdentityOptions, (option) => (
          <StyledFormikCheckbox
            key={option.value}
            saveAsOption
            value={option.value}
            label={option.label}
            groupName={name}
          />
        ))}
      </div>
    </>
  );
};

export default memo(AdditionallyIdentifiesAs);
